<template>
  <div class="main">
    <a-form :form="form" class="user-layout-login" ref="formLogin" id="formLogin">
      <a-tabs
        :activeKey="customActiveKey"
        :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change="handleTabClick"
      >
        <a-tab-pane key="tab1" tab="账号密码登陆">
          <a-form-item>
            <a-input
              size="large"
              v-decorator="['username', validatorRules.username, { validator: this.handleUsernameOrEmail }]"
              type="text"
              placeholder="请输入帐户名"
            >
              <a-icon slot="prefix" type="user" :style="{ color: '#58acb8' }" width="2em" height="2em" />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              v-decorator="['password', validatorRules.password]"
              size="large"
              type="password"
              autocomplete="false"
              placeholder="密码"
            >
              <a-icon slot="prefix" type="lock" :style="{ color: '#58acb8' }" />
            </a-input>
          </a-form-item>

          <a-row :gutter="0"   v-if="isValidateCode" >
            <a-col :span="16">
              <a-form-item>
                <a-input
                  v-decorator="['inputCode', validatorRules.inputCode]"
                  size="large"
                  type="text"
                  @change="inputCodeChange"
                  placeholder="请输入验证码"
                >
                  <a-icon slot="prefix" type="smile" :style="{ color: '#58acb8' }" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8" style="text-align: right">
              <img
                v-if="requestCodeSuccess"
                style="margin-top: 2px"
                :src="randCodeImage"
                @click="handleChangeCheckCode"
              />
              <img v-else style="margin-top: 2px" src="../../assets/checkcode.png" @click="handleChangeCheckCode" />
              <!--<j-graphic-code @success="generateCode" ref="jgraphicCodeRef" style="float: right" remote></j-graphic-code>-->
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="tab2" tab="手机号登陆">
          <a-form-item>
            <a-input v-decorator="['mobile', validatorRules.mobile]" size="large" type="text" placeholder="手机号">
              <a-icon slot="prefix" type="mobile" :style="{ color: '#58acb8' }" />
            </a-input>
          </a-form-item>

          <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input
                  v-decorator="['captcha', validatorRules.captcha]"
                  size="large"
                  type="text"
                  placeholder="请输入验证码"
                >
                  <a-icon slot="prefix" type="mail" :style="{ color: '#58acb8' }" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <a-button
                class="getCaptcha"
                tabindex="-1"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCaptcha"
                v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'"
              ></a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <a-form-item>
        <a-checkbox v-decorator="['rememberMe', { initialValue: true, valuePropName: 'checked' }]">自动登陆</a-checkbox>
        <a @click="forgetPassword" class="forge-password" style="float: right"> 忘记密码 </a>
        <!-- <router-link :to="{ name: 'register'}" class="forge-password" style="float: right;margin-right: 10px" >
          注册账户
        </router-link> -->
      </a-form-item>

      <a-form-item style="margin-top: 24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="loginBtn"
          @click.stop.prevent="handleSubmit"
          :disabled="loginBtn"
          >确定
        </a-button>
      </a-form-item>

      <!-- <div class="user-login-other">
        <span>其他登陆方式</span>
        <a><a-icon class="item-icon" type="alipay-circle"></a-icon></a>
        <a><a-icon class="item-icon" type="taobao-circle"></a-icon></a>
        <a><a-icon class="item-icon" type="weibo-circle"></a-icon></a>
        <router-link class="register" :to="{ name: 'register' }">
          注册账户
        </router-link>
      </div>-->
    </a-form>

    <two-step-captcha
      v-if="requiredTwoStepCaptcha"
      :visible="stepCaptchaVisible"
      @success="stepCaptchaSuccess"
      @cancel="stepCaptchaCancel"
    ></two-step-captcha>

    <a-modal title="登录部门选择" :width="450" :visible="departVisible" :closable="false" :maskClosable="false">
      <template slot="footer">
        <a-button type="primary" @click="departOk">确认</a-button>
      </template>

      <a-form>
        <a-form-item
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 20 }"
          style="margin-bottom: 10px"
          :validate-status="validate_status"
        >
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>您隶属于多部门，请选择登录部门</span>
            </template>
            <a-avatar style="backgroundcolor: #87d068" icon="gold" />
          </a-tooltip>
          <a-select
            @change="departChange"
            :class="{ 'valid-error': validate_status == 'error' }"
            placeholder="请选择登录部门"
            style="margin-left: 10px; width: 80%"
          >
            <a-icon slot="suffixIcon" type="gold" />
            <a-select-option v-for="d in departList" :key="d.id" :value="d.orgCode">
              {{ d.departName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
//import md5 from "md5"
import api from '@/api'
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import Vue from 'vue'
import { ACCESS_TOKEN, ENCRYPTED_STRING } from '@/store/mutation-types'
import JGraphicCode from '@/components/jeecg/JGraphicCode'
import { putAction, postAction, getAction,httpAction } from '@/api/manage'
import { encryption, getEncryptedString } from '@/utils/encryption/aesEncrypt'
import store from '@/store/'
import { USER_INFO } from '@/store/mutation-types'
import axios from 'axios'

export default {
  components: {
    TwoStepCaptcha,
    JGraphicCode,
  },
  data() {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      isValidateCode:false,
      encryptedString: {
        key: '',
        iv: '',
      },
      state: {
        time: 60,
        smsSendBtn: false,
      },
      validatorRules: {
        username: { rules: [{ required: true, message: '请输入用户名!' }, { validator: this.handleUsernameOrEmail }] },
        password: { rules: [{ required: true, message: '请输入密码!', validator: 'click' }] },
        mobile: { rules: [{ validator: this.validateMobile }] },
        captcha: { rule: [{ required: true, message: '请输入验证码!' }] },
        inputCode: { rules: [{ required: true, message: '请输入验证码!' }] },
      },
      verifiedCode: '',
      inputCodeContent: '',
      inputCodeNull: true,

      departList: [],
      departVisible: false,
      departSelected: '',
      currentUsername: '',
      validate_status: '',
      currdatetime: '',
      randCodeImage: '',
      requestCodeSuccess: false,
    }
  },
  created() {
    this.currdatetime = new Date().getTime()
    Vue.ls.remove(ACCESS_TOKEN)
    this.getRouterData()
    this.requestCodeSuccess=false
    // this.handleChangeCheckCode()
    // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
    //this.getEncrypte();
    // update-end- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
  },
  watch:{
    isValidateCode(newVal){
      console.log(newVal)
      this.changePannelsImg()
    }
  },
  methods: {
    ...mapActions(['Login', 'Logout', 'PhoneLogin']),
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        this.loginType = 0
      } else {
        this.loginType = 1
      }
      callback()
    },
    handleTabClick(key) {
      this.customActiveKey = key
      this.changePannelsImg()
      // this.form.resetFields()
    },
    handleSubmit() {
      let that = this
      let loginParams = {}
      that.loginBtn = true
      // 使用账户密码登陆
      if (that.customActiveKey === 'tab1') {
         if (that.isValidateCode) {
          that.form.validateFields(['username', 'password', 'inputCode', 'rememberMe'], { force: true }, (err, values) => {
            if (!err) {
              loginParams.username = values.username
              // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
              //loginParams.password = md5(values.password)
              //loginParams.password = encryption(values.password,that.encryptedString.key,that.encryptedString.iv)
              loginParams.password = values.password
              loginParams.remember_me = values.rememberMe
              // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
              loginParams.captcha = that.inputCodeContent
              loginParams.checkKey = that.currdatetime
              console.log("登录参数", loginParams)
              that.Login(loginParams).then((res) => {
                console.log('账号登录', res.result);
                this.departConfirm(res)
              }).catch((err) => {
                if (err.result) {
                  that.isValidateCode = err.result.isValidateCode
                }
                that.requestFailed(err);
              });

            } else {
              that.loginBtn = false;
            }
          })
        } else {
          let username = that.form.getFieldValue('username')
          httpAction('/sys/checkLoginNum', { username }, 'post').then((res) => {
            if (res.success) {
              that.form.validateFields(['username', 'password', 'inputCode', 'rememberMe'], { force: true }, (err, values) => {
                if (!err) {
                  loginParams.username = values.username
                  // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
                  //loginParams.password = md5(values.password)
                  //loginParams.password = encryption(values.password,that.encryptedString.key,that.encryptedString.iv)
                  loginParams.password = values.password
                  loginParams.remember_me = values.rememberMe
                  // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
                  loginParams.captcha = that.inputCodeContent
                  loginParams.checkKey = that.currdatetime
                  console.log("登录参数", loginParams)
                  that.Login(loginParams).then((res) => {
                    console.log('账号登录', res.result);
                    this.departConfirm(res)
                  }).catch((err) => {
                    if (err.result) {
                      that.isValidateCode = err.result.isValidateCode
                    }
                    that.requestFailed(err);
                  });

                } else {
                  that.loginBtn = false;
                }
              })
            } else {
              that.requestFailed(res);
              this.isValidateCode = true;
              this.handleChangeCheckCode();
            }
          }).finally(() => {
            that.confirmLoading = false;

          })
        }
        // 使用手机号登陆
      } else {
        that.form.validateFields(['mobile', 'captcha', 'rememberMe'], { force: true }, (err, values) => {
          if (!err) {
            loginParams.mobile = values.mobile
            loginParams.captcha = values.captcha
            loginParams.remember_me = values.rememberMe
            that
              .PhoneLogin(loginParams)
              .then((res) => {
                console.log(res.result)
                this.departConfirm(res)
              })
              .catch((err) => {
                that.requestFailed(err)
              })
          }
        })
      }
    },
    getCaptcha(e) {
      e.preventDefault()
      let that = this
      this.form.validateFields(['mobile'], { force: true }, (err, values) => {
        if (!values.mobile) {
          that.cmsFailed('请输入手机号')
        } else if (!err) {
          this.state.smsSendBtn = true
          let interval = window.setInterval(() => {
            if (that.state.time-- <= 0) {
              that.state.time = 60
              that.state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)

          const hide = this.$message.loading('验证码发送中..', 0)
          let smsParams = {}
          smsParams.mobile = values.mobile
          smsParams.smsmode = '0'
          postAction('/sys/sms', smsParams)
            .then((res) => {
              if (!res.success) {
                setTimeout(hide, 0)
                this.cmsFailed(res.message)
              }
              console.log(res)
              setTimeout(hide, 500)
            })
            .catch((err) => {
              setTimeout(hide, 1)
              clearInterval(interval)
              that.state.time = 60
              that.state.smsSendBtn = false
              this.requestFailed(err)
            })
        }
      })
    },
    stepCaptchaSuccess() {
      this.loginSuccess()
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime()
      getAction(`/sys/randomImage/${this.currdatetime}`)
        .then((res) => {
          if (res.success) {
            this.randCodeImage = res.result
            this.requestCodeSuccess = true
          } else {
            this.$message.error(res.message)
            this.requestCodeSuccess = false
          }
        })
        .catch(() => {
          this.requestCodeSuccess = false
        })
    },
    loginSuccess() {
      // update-begin- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      // this.loginBtn = false
      // update-end- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      let name="";
      const SysIdentityCode = sessionStorage.getItem('SysIdentityCode')
      if(SysIdentityCode=='sys-code-visitor'){
       name= 'gisVisitorBase-VisitorList'
      }else{
        name= 'dashboard'
      }
      
      this.$router.push({ name: name })
      this.$notification.success({
        message: '欢迎',
        description: `${timeFix()}，欢迎回来`,
      })
    },
    cmsFailed(err) {
      this.$notification['error']({
        message: '登录失败',
        description: err,
        duration: 4,
      })
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || '请求出现错误，请稍后再试',
        duration: 4,
      })
      this.loginBtn = false
    },
    validateMobile(rule, value, callback) {
      if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
        callback()
      } else {
        callback('您的手机号码格式不正确!')
      }
    },
    validateInputCode(rule, value, callback) {
      if (!value || this.verifiedCode == this.inputCodeContent) {
        callback()
      } else {
        callback('您输入的验证码不正确!')
      }
    },
    generateCode(value) {
      this.verifiedCode = value.toLowerCase()
    },
    inputCodeChange(e) {
      this.inputCodeContent = e.target.value
    },
    departConfirm(res) {
      if (res.success) {
        let multi_depart = res.result.multi_depart
        //0:无部门 1:一个部门 2:多个部门
        if (multi_depart == 0) {
          this.loginSuccess()
          this.$notification.warn({
            message: '提示',
            description: `您尚未归属部门,请确认账号信息`,
            duration: 3,
          })
        } else if (multi_depart == 2) {
          this.departVisible = true
          this.currentUsername = this.form.getFieldValue('username')
          this.departList = res.result.departs
        } else {
          this.loginSuccess()
        }
        this.decisionToken(res.result.userInfo.username)
      } else {
        this.requestFailed(res)
        this.Logout()
      }
    },
    departOk() {
      if (!this.departSelected) {
        this.validate_status = 'error'
        return false
      }
      let obj = {
        orgCode: this.departSelected,
        username: this.form.getFieldValue('username'),
      }
      putAction('/sys/selectDepart', obj).then((res) => {
        if (res.success) {
          const userInfo = res.result.userInfo
          Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
          store.commit('SET_INFO', userInfo)
          //console.log("---切换组织机构---userInfo-------",store.getters.userInfo.orgCode);
          this.departClear()
          this.loginSuccess()
        } else {
          this.requestFailed(res)
          this.Logout().then(() => {
            this.departClear()
          })
        }
      })
    },
    departClear() {
      this.departList = []
      this.departSelected = ''
      this.currentUsername = ''
      this.departVisible = false
      this.validate_status = ''
    },
    departChange(value) {
      this.validate_status = 'success'
      this.departSelected = value
    },
    getRouterData() {
      this.$nextTick(() => {
        if (this.$route.params.username) {
          this.form.setFieldsValue({
            username: this.$route.params.username,
          })
        }
      })
    },
    //获取密码加密规则
    getEncrypte() {
      var encryptedString = Vue.ls.get(ENCRYPTED_STRING)
      if (encryptedString == null) {
        getEncryptedString().then((data) => {
          this.encryptedString = data
        })
      } else {
        this.encryptedString = encryptedString
      }
    },
    //决策平台单点登录
    loginDecision(username, password) {
      console.log('决策平台登录参数username：' + username + ' password:' + password)
      let params = {
        fine_username: username,
        fine_password: password,
        validity: -1,
      }
      this.jsonp('https://app1.canc.com.cn:8334/webroot/decision/login/cross/domain', params)
        .then((res) => {
          if (res.status == 'success') {
            console.log('决策平台登录成功', res)
            // window.open('https://app1.canc.com.cn:8334/webroot/decision');
          } else {
            console.log('决策平台登录失败', res)
          }
        })
        .catch((error) => {
          console.log('决策平台登录出错', error)
        })
    },
    //决策平台单点登录token获取
    decisionToken(username) {
      if (username == undefined || username == '') {
        return
      }
      if (username == 'admin') {
        return
      }
      let that = this
      console.log('决策平台登录token获取参数username：' + username)
      axios
        .post('https://crm.g-home.cn/jrest/sys/sso/ssoFineToken', {})
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.code == 0 && response.data.token != null) {
              var token = response.data.token
              // console.log("决策平台token:",token);
              that.loginDecision(username, token)
            }
          }
        })
        .catch(function (error) {
          console.log('决策平台获取token出错', error)
        })
    },
    changePannelsImg(){
      if(document.documentElement.clientWidth>479){
        if(this.customActiveKey=="tab1"){
          if(this.isValidateCode){
            document.getElementById("containerbox").style.background = "url("+require("../../assets/loginpanel1.png")+")"
            document.getElementById("containerbox").style.width="550px";
            document.getElementById("containerbox").style.height="578px";
            document.getElementById("containerbox").style.backgroundRepeat="no-repeat";
            document.getElementById("containerbox").style.backgroundClip="border-box";
            document.getElementById("containerbox").style.backgroundSize="contain";
          }else{
            document.getElementById("containerbox").style.background = "url("+require("../../assets/loginpanel2.png")+")"
            document.getElementById("containerbox").style.width="550px";
            document.getElementById("containerbox").style.height="527px";
            document.getElementById("containerbox").style.backgroundRepeat="no-repeat";
            document.getElementById("containerbox").style.backgroundClip="border-box";
            document.getElementById("containerbox").style.backgroundSize="contain";
          }
        }else if(this.customActiveKey=="tab2"){
          document.getElementById("containerbox").style.background = "url("+require("../../assets/loginpanel2.png")+")"
          document.getElementById("containerbox").style.width="550px";
          document.getElementById("containerbox").style.height="527px";
          document.getElementById("containerbox").style.backgroundRepeat="no-repeat";
          document.getElementById("containerbox").style.backgroundClip="border-box";
          document.getElementById("containerbox").style.backgroundSize="contain";
        }
      }
    },
    forgetPassword() {
      window.open('https://ekp.canc.com.cn/sys/organization/sys_org_retrieve_password/validateUser.jsp');
    },
  },
}
</script>

<style lang="less" scoped>
.user-layout-login {
  label {
    font-size: 14px;
    color: #58acb8;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
    background-color: #58acb8;
    border-color: #58acb8;
  }

  .forge-password {
    font-size:14px;
    color: #58acb8;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 20px;
    height: 50px;
    width: 100%;
    background-color: #58acb8;
    border-color: #58acb8;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
<style  scoped>
.main {
 position:relative;
 top:18px;
}
/deep/.valid-error .ant-select-selection__placeholder {
  color: #f5222d;
}
/deep/.ant-tabs-nav .ant-tabs-tab{
  font-size: 20px !important;
  font-weight: 500 !important;
  color:#27495f !important;
}
/deep/.ant-tabs-nav .ant-tabs-tab:hover {
    color: #58acb8 !important;
}
/deep/.ant-tabs-nav .ant-tabs-tab-active {
    color: #58acb8 !important;
    font-weight: 500;
}
/deep/.ant-tabs-ink-bar { 
  background: #58acb8;
  width: 50px!important;
  margin-left: 60px!important;
}
/deep/.ant-input { 
  border-color:#27495f !important;
  background-color: transparent !important;
  color:#ffffff !important;
  font-size: 14px;
}
/deep/.ant-input::-webkit-input-placeholder{
  font-size: 14px;
}
/deep/.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
    border-color: #58acb8!important;
    border-right-width: 1px !important;
}
/deep/.ant-input:focus{ 
    border-color: #58acb8!important;
}
/deep/.getCaptcha:hover{
    color: #ffffff    !important;
}
/deep/.getCaptcha{
  background-color: transparent !important;
  color:#58acb8 !important;
}
/deep/.ant-checkbox-checked .ant-checkbox-inner {
    width:14px !important;
    height:14px !important;
    background-color: #58acb8    !important;
    border-color: #58acb8    !important;
}
/deep/.ant-checkbox-checked .ant-checkbox-inner::after {
    position: absolute;
    display: table;
    border: 2px solid #fff;
    border-top: 0;
    border-left: 0;
    transform: rotate(45deg) scale(0.9) translate(-75%, -60%);
    opacity: 1;
    transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    content: ' ';
}
/deep/.ant-tabs-top-content{
  margin-bottom: -5px !important;
}
</style>
